import React from 'react';
import HomeFiveMain from './HomeFiveMain';
import HeaderFive from '../../components/Header/HeaderFive';
import FooterThree from '../../components/Footer/FooterThree';

const HomeFiveOnePage = () => {
  return (
    <>
      <HeaderFive isOnePage />

      <HomeFiveMain />

      <FooterThree />
    </>
  );
};

export default HomeFiveOnePage;
